// extracted by mini-css-extract-plugin
export default {"wrap":"loading_wrap__xn8Ko","full":"loading_full__2kscP","container":"loading_container__qMIsS","loading":"loading_loading__YwuKn","icon":"loading_icon__tniwH"};